
define('text!templates/widgets/dataGridCells/filters/enumFilter.html',[],function () { return '<div class="search-container">\n    <select class="form-control input-sm" data-bind="attr: {id: id},\n        options: options,\n        optionsText: &apos;enumText&apos;,\n        value: selectedEnum"></select>\n</div>';});

